/**
 * Sanitiza HTML permitindo apenas tags básicas e seguras
 * @param {string} html - HTML a ser sanitizado
 * @returns {string} - HTML sanitizado
 */
export function sanitizeBasicHtml(html) {
  if (!html || typeof html !== 'string') {
    return '';
  }

  // Tags permitidas (apenas formatação básica, sem JavaScript)
  const allowedTags = [
    'br', 'p', 'strong', 'b', 'em', 'i', 'u', 
    'span', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'ul', 'ol', 'li', 'blockquote', 'a'
  ];

  // Remove todas as tags que não estão na lista de permitidas
  let sanitized = html.replace(/<(?!\/?(?:br|p|strong|b|em|i|u|span|div|h[1-6]|ul|ol|li|blockquote|a)\b)[^>]*>/gi, '');

  // Remove todos os atributos das tags, exceto href para links
  sanitized = sanitized.replace(/<a([^>]*?)>/g, (match, attributes) => {
    const hrefMatch = attributes.match(/href=["']([^"']*?)["']/);
    if (hrefMatch && (hrefMatch[1].startsWith('http://') || hrefMatch[1].startsWith('https://') || hrefMatch[1].startsWith('www.'))) {
      return `<a href="${hrefMatch[1]}" target="_blank" rel="noopener noreferrer">`;
    }
    return '<a>';
  });
  
  sanitized = sanitized.replace(/<(\w+)([^>]*?)>/g, (match, tag, attributes) => {
    if (tag === 'a') return match; // Links já foram processados acima
    return `<${tag}>`;
  });

  // Decodifica entidades HTML comuns
  sanitized = sanitized
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&nbsp;/g, ' ');

  // Corrige tags br codificadas
  sanitized = sanitized.replace(/&lt;\/br&gt;|&lt;br\/&gt;|&lt;br&gt;/gi, '<br>');

  return sanitized;
} 